module.exports = __webpack_public_path__ + "img/netherlands.fea4b1fc.jpg";